import React, { useState } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { formatNumber2 } from "../../../../utils/currencyFormat"

export const TableDanhSach = ({ listHopDong, isLoading, dataSearch, setDataSearch, onSearch, selectedHopDong, setSelectedHopDong, onOpenModalHopDong, onOpenModalKhachHang }) => {

    const handlePageChange = (pageNumber) => {
        const newSearchData = { ...dataSearch, pageIndex: pageNumber };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };
    
    return (
        <div className="form form-horizontal">
            <div className="form-body">
                <div className="Left808x200 Table-main-new css-table-ds">
                    <div className="table-mobile table-mobile-hover">
                        <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                            <div className="table-headers" style={{alignItems: 'stretch'}}>
                                <div className="custom-table-header text-center flex-basis-5 flex-basis-5-sm">
                                    <p className="color-do-bold">STT<br />[{listHopDong.iTotal}]</p>
                                </div>
                                <div className="custom-table-header text-left flex-basis-12 flex-basis-12-sm">
                                    <p>Mã hợp đồng</p>
                                </div>
                                <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                    <p>Tên khách hàng</p>
                                </div>
                                <div className="custom-table-header text-left flex-basis-10 flex-basis-10-sm">
                                    <p>Thời gian vay</p>
                                </div>
                                <div className="custom-table-header text-right flex-basis-12 flex-basis-12-sm">
                                    <p className="color-do-bold">Số tiền vay <br /> [{formatNumber2(listHopDong.TotalSoTienVay)}]</p>
                                </div>
                                <div className="custom-table-header text-right flex-basis-12 flex-basis-12-sm">
                                    <p className="color-do-bold">Số tiền đã trả <br /> [{formatNumber2(listHopDong.TotalSoTienDaTra)}]</p>
                                </div>
                                <div className="custom-table-header text-right flex-basis-12 flex-basis-12-sm">
                                    <p className="color-do-bold">Số tiền thanh toán <br /> [{formatNumber2(listHopDong.TotalSoTienThanhToan)}]</p>
                                </div>
                                <div className="custom-table-header text-center flex-basis-13 flex-basis-13-sm">
                                    <p>Quá hạn</p>
                                </div>
                                <div className="custom-table-header text-left flex-basis-9 flex-basis-9-sm">
                                    <p>Tình trạng</p>
                                </div>
                            </div>
                            <div className="custom-table-body">
                                {isLoading ? (
                                    <div className="loading-page1"><div className="loader loader-default is-active"></div></div> 
                                ) : (
                                    <ContentTable
                                        listHopDong={listHopDong.List}
                                        selectedHopDong={selectedHopDong}
                                        setSelectedHopDong={setSelectedHopDong}
                                        onOpenModalHopDong={onOpenModalHopDong}
                                        onOpenModalKhachHang={onOpenModalKhachHang}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {listHopDong.iTotal > dataSearch.pageSize && (
                <div className="row">
                    <div className="col-sm-12 col-md-6 d-flex align-items-center">
                        <span className="color7">Hiển thị {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} - {Math.min(dataSearch.pageIndex * dataSearch.pageSize, listHopDong.iTotal)} / {listHopDong.iTotal}</span>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="d-flex justify-content-end">
                            <Pagination
                                activePage={dataSearch.pageIndex}
                                itemsCountPerPage={dataSearch.pageSize}
                                totalItemsCount={listHopDong.iTotal}
                                pageRangeDisplayed={5}
                                onChange={handlePageChange}
                                itemClass="page-item border-none"
                                linkClass="page-link border-none"
                                activeClass="active"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};